<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">生活服务场景介绍</p>
        <p>一站式解决用户生活服务难题</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p
          v-for="(nl, index) in navList"
          :key="index"
          :class="anchorId == index ? 'nowAnchor' : ''"
          @click="changeanchorId(index, nl.id)"
        >
          {{ nl.text }}
        </p>
      </div>
    </div>
    <!-- 场景简介 -->
    <section class="first-introduce flexDiv mainDivWidth">
      <div class="introduceTextImg">
        <img
          src="static/img/sceneImg/scene3-LifeSer/firstImg.png"
          class="introduceImg"
        />
      </div>
      <div class="first-introduceText">
        <div class="introduceText-Title flexDiv">
          <p class="titleBg">场景现状</p>
          <p class="subheading">Scene introduction</p>
        </div>
        <div class="cer-FunCon">
          <p>
            截至目前，生活服务场景已完成8大核心产品对接，日交易量达2万余笔，日总交易金额达200余万元，接入银行、企事业单位等130多个渠道，覆盖用户上百万。
          </p>
        </div>
      </div>
    </section>
    <!-- 中心功能 -->
    <section class="centralFunction" id="centralFunction">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">中心功能</h3>
        <p class="advantageText smallRadius pointer">
          生活服务产品以便民为核心，搭建全新综合支付平台，构建行业应用体系中重要的一环---内容服务，业务覆盖水电气缴费、手机充值、
          固话缴费、视频会员、音乐会员、数娱会员、商超电子卡、交通罚款等丰富的生活服务功能，满足银行、企业一站式对接多种应用需求，
          解决接入应用难、维护成本高等难题。
        </p>
      </div>
    </section>
    <!-- 已开通应用 -->
    <section id="OpenApplicate">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">已开通应用</h3>
        <div class="OpenApplicate flexDiv">
          <div
            class="OpenApplicate-Con"
            v-for="(mas, index) in openApplicateList"
            :key="index"
            v-bind:style="{ 'background-image': 'url(' + mas.pics + ')' }"
          >
            <div class="model"></div>
            <p class="ApplicateText flexDiv">{{ mas.title }}</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 接入方式 -->
    <section class="joinUpFun" id="joinUpFun">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">接入方式</h3>
        <div class="joinUpFun-Con flexDiv">
          <div>
            <div class="imgDiv">
              <img src="static/img/sceneImg/scene3-LifeSer/joinUp01.png" />
            </div>
            <p class="title">标准模式</p>
            <p>移动、互联网前端（APP/微信公众号H5嵌入）</p>
          </div>
          <div>
            <div class="imgDiv">
              <img src="static/img/sceneImg/scene3-LifeSer/joinUp02.png" />
            </div>
            <p class="title">接口模式</p>
            <p>开放API应用接口，支持深度个性化定制</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 接入优势 -->
    <section id="joinUpAdvantage" class="joinUpAdvantage">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">接入优势</h3>
        <div
          class="joinUpdetail flexDiv"
          v-for="(jl, index) in joinUpAdvantageList"
          :key="index"
        >
          <img :src="jl.img" />
          <p v-text="jl.text"></p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "sceneLifeSer",
  data: function() {
    return {
      anchorId: 0,
      navList: [
        { text: "中心功能", id: "centralFunction" },
        { text: "已开通应用", id: "OpenApplicate" },
        { text: "接入方式", id: "joinUpFun" },
        { text: "接入优势", id: "joinUpAdvantage" }
      ],
      openApplicateList: [
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon01.png",
          title: "缴电费"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon02.png",
          title: "缴水费"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon03.png",
          title: "缴燃气费"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon04.png",
          title: "手机充值"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon05.png",
          title: "固话宽带"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon06.png",
          title: "数娱会员"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon07.png",
          title: "交通罚款"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon08.png",
          title: "加油卡充值"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon09.png",
          title: "信用卡还款"
        },
        {
          pics: "static/img/sceneImg/scene3-LifeSer/openIcon10.png",
          title: "礼品卡充值"
        }
      ],
      joinUpAdvantageList: [
        {
          img: "static/img/sceneImg/scene3-LifeSer/joinAdv01.png",
          text: "丰富自身平台场景，优化平台功能"
        },
        {
          img: "static/img/sceneImg/scene3-LifeSer/joinAdv02.png",
          text: "提升用户权益，释放营销资源费用"
        },
        {
          img: "static/img/sceneImg/scene3-LifeSer/joinAdv03.png",
          text: "带动平台交易量，拉动新用户注册"
        }
      ],
      idconts:"",
    };
  },
  created(){
    this.idconts = this.getQueryString('idcont');
  },
  mounted() {
    if(this.idconts){
      $(".mainCon").css('margin-top','0')
      $("#nava").css('display','none')
      $(".scene-Header").css('display','none')
      $(".servebanner").css('display','none')
      $(".footer").css('display','none')
    }
  },
  methods: {
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id) {
      this.anchorId = num;
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      return false; // 返回false可以避免在原链接后加上#
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return r[2]; return null;
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/sceneCss/sceneStyle";
@import "../../assets/css/sceneCss/sceneThree";
</style>



// WEBPACK FOOTER //
// src/pages/scenePage/scene3-lifeSer.vue